export default __webpack_public_path__ + "static/media/line_grey.81ab2928.svg";